module.exports = __webpack_public_path__ + "static/img/1000000501.79add64d.jpg";